import { Routes } from '@angular/router';
import { CheckoutDetailsComponent } from './components/checkout-details/checkout-details.component';

export const routes: Routes = [
  {
    path: '',
    component: CheckoutDetailsComponent
  }
];
